export default __webpack_public_path__ + "static/media/F1_5.131c66f3.png";